import { ModalActionTypes } from '@acorns/web-components'

export const generateErrorCodeMap = (props, values) => {
  return new Map([
    [
      'institution_not_supported',
      [
        {
          title: 'Invalid routing number',
          message: 'There is no bank associated with this routing number.',
          field: 'routingNumber',
          actions: [
            {
              type: ModalActionTypes.primary,
              label: 'Go Back',
              handler: props.closeErrorModal,
            },
          ],
        },
      ],
    ],
    [
      'invalid_account_number',
      [
        {
          title: 'Invalid account number',
          message: 'Please double check your account number.',
          field: 'accountNumber',
          actions: [
            {
              type: ModalActionTypes.primary,
              label: 'Go Back',
              handler: props.closeErrorModal,
            },
          ],
        },
      ],
    ],
  ])
}
